module.exports = __webpack_public_path__ + "img/sSuperFor_350x350.6c213b46.jpg";